module.exports = __webpack_public_path__ + "static/img/9.917eac8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/winter/gift/9.png
// module id = euES
// module chunks = 2